<script>
  import { setContext, getContext, createEventDispatcher } from 'svelte';
  import { writable } from 'svelte/store';
  import router from './router';
  import { currentRoute } from './routerState';
  import LoadingFallback from './Loading.svelte';
  import ErrorFallback from './Error.svelte';


  export let animation = false;
  
  const dispatch = createEventDispatcher();

  const ctx = getContext('_routerDepth');
  const depth = ctx || ctx === 0 ? ctx + 1 : 0;
  setContext('_routerDepth', depth);

  let component = new Promise(() => {});
  let componentDummy = true;
  let contentWrapper;
  let contentClass = [ 'content' ];
  let contentBlock = {
    el: null,
  };

  const eventName = 'WebkitTransition' in document.documentElement.style ? 'webkitTransitionEnd' : 'transitionend';


  /* hideComponent */
  function hideComponent() {
    dispatch('componentHide');
    return new Promise(
      resolve => {
        contentWrapper.addEventListener(eventName, () => resolve(), { once: true });
        contentClass = [ 'content', 'hidden' ];
      }
    );
  }


  /* update */
  async function update() {
    const res = router._component(depth);
    if (res && res.update) {
      if (animation) {
        if (!componentDummy)
          await hideComponent();
        contentClass = [ 'content', 'prepared' ];
        component = res.component;
        componentDummy = false;
        dispatch('componentChange');
        setTimeout(() => contentClass = [ 'content' ], 10);
      }
      else {
        component = res.component;
        componentDummy = false;
        dispatch('componentChange');
      }
    }
  }


  /* updateWrapper */
  function updateWrapper(el) {
    contentWrapper = el;
    contentBlock.el = contentWrapper;
  }


  $: {
    if ($currentRoute.urn)
      update();
  }
</script>


<style>
  .content {
    position: relative;
    height: 100%;
    width: 100%;
    margin-left: 0px;
    opacity: 1;
    overflow-x: hidden;
    overflow-y: auto;
		-webkit-transition: margin-left .3s, opacity .3s;
		transition: margin-left .3s, opacity .3s;
  }

  .prepared {
    margin-left: -30px;
    opacity: 0;
    -webkit-transition: margin-left 0s, opacity 0s;
		transition: margin-left 0s, opacity 0s;
  }

  .hidden {
    margin-left: 30px;
    opacity: 0;
  }
</style>


{#await component}
  <slot name="loading">
    <LoadingFallback />
  </slot>
{:then result}
  <div
    class="{contentClass.join(' ')}"
    use:updateWrapper
  >
    <svelte:component this="{result}" params="{$currentRoute.params}" contentWrapper="{contentBlock}"/>
  </div>
{:catch error}
	<slot name="error">
    <ErrorFallback message="{error.message}" />
  </slot>
{/await}
